import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";

import Messages from "core/Messages";
import ErrorModal from "./ErrorModal";

import { BannerContainer } from "./styles";

import { getMessageText } from "./helpers";

const PhotoUploadUploadStatus = ({
    uploadsInDropzoneCount = 0,
    allFailedUploadsCount = 0,
    currentlyProcessingCount = 0,
    uploadErrors = []
}) => {
    const [messageDisplayPaused, setMessageDisplayPaused] = useState(false);
    const [showMessage, setShowMessage] = useState(false);

    const [errorModalIsOpen, setErrorModalIsOpen] = useState(false);
    const openErrorModal = () => setErrorModalIsOpen(true);
    const closeErrorModal = () => setErrorModalIsOpen(false);

    const prevProcessingCount = useRef(0);

    useEffect(() => {
        if (messageDisplayPaused) return;

        // show message when uploading begins
        // OR show message if there are any upload errors
        if (
            (prevProcessingCount.current === 0 &&
                currentlyProcessingCount > 0) ||
            allFailedUploadsCount > 0
        ) {
            setShowMessage(true);
        }

        prevProcessingCount.current = currentlyProcessingCount;
    }, [currentlyProcessingCount, messageDisplayPaused, allFailedUploadsCount]);

    useEffect(() => {
        if (messageDisplayPaused) {
            // if user dismisses banner, it should stay
            // dismissed for at least 10 seconds
            setTimeout(() => setMessageDisplayPaused(false), [10000]);
        }
    }, [messageDisplayPaused]);

    const handleDismissClick = () => {
        setShowMessage(false);
        // dismissing banner will pause showing
        // banner again for 10 seconds
        setMessageDisplayPaused(true);
    };

    if (!showMessage) return null;

    return (
        <BannerContainer>
            <Messages
                overrideDismissClick={handleDismissClick}
                styleType="solid"
                isDismissable
                infoType="neutral"
            >
                {getMessageText(
                    uploadsInDropzoneCount,
                    allFailedUploadsCount,
                    currentlyProcessingCount,
                    openErrorModal
                )}
            </Messages>
            <ErrorModal
                open={errorModalIsOpen}
                handleClose={closeErrorModal}
                uploadErrors={uploadErrors}
            />
        </BannerContainer>
    );
};

PhotoUploadUploadStatus.propTypes = {
    uploadsInDropzoneCount: PropTypes.number.isRequired,
    allFailedUploadsCount: PropTypes.number.isRequired,
    currentlyProcessingCount: PropTypes.number.isRequired,
    uploadErrors: PropTypes.array.isRequired
};

export default PhotoUploadUploadStatus;
